/**
 * Sumele pe care clientul trebuie sa le inteleaga INAINTE de checkout.
 *
 * Serverul ramane autoritatea si recalculeaza cotatia finala. Aici nu se alege
 * nicio zona si niciun restaurant: se prezinta doar regulile deja intoarse de
 * verificarea adresei, astfel incat minimul si taxa sa nu apara ca surprize la
 * pasul urmator.
 */

export interface DeliveryProgressInput {
  subtotal: number;
  deliveryFee: number;
  minOrderValue: number;
  freeDeliveryThreshold?: number | null;
}

export interface DeliveryProgress {
  minimumReached: boolean;
  remainingToMinimum: number;
  remainingToFreeDelivery: number | null;
  effectiveDeliveryFee: number;
  total: number;
  minimumPercent: number;
  freeDeliveryPercent: number | null;
}

function percent(value: number, target: number): number {
  if (target <= 0) return 100;
  return Math.min(100, Math.max(0, Math.round((value / target) * 100)));
}

export function deliveryProgress(input: DeliveryProgressInput): DeliveryProgress {
  const subtotal = Math.max(0, input.subtotal);
  const minOrderValue = Math.max(0, input.minOrderValue);
  const deliveryFee = Math.max(0, input.deliveryFee);
  const threshold =
    typeof input.freeDeliveryThreshold === "number" && input.freeDeliveryThreshold >= 0
      ? input.freeDeliveryThreshold
      : null;
  const remainingToMinimum = Math.max(0, minOrderValue - subtotal);
  const remainingToFreeDelivery = threshold === null ? null : Math.max(0, threshold - subtotal);
  const effectiveDeliveryFee = threshold !== null && subtotal >= threshold ? 0 : deliveryFee;

  return {
    minimumReached: remainingToMinimum === 0,
    remainingToMinimum,
    remainingToFreeDelivery,
    effectiveDeliveryFee,
    total: subtotal + effectiveDeliveryFee,
    minimumPercent: percent(subtotal, minOrderValue),
    freeDeliveryPercent: threshold === null ? null : percent(subtotal, threshold),
  };
}
